// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-foot {
  display: none;
}

.sr-only {
  display: none;
}

.react-bs-table-no-data {
  text-align: center;
}

.export-container {
  text-align: end;
}
.search-student {
  display: grid;
}

.search-result {
  margin-top: 10px;
}

.rank-custom-cell {
  width: 8%;
}

.number-custom-cell {
  width: 4%;
}

.sort-text {
  margin-right: 20px;
}

.fa-spin {
  margin-right: 5px;
}

.student-container {
  margin-bottom: 500px;
  margin-top: 70px !important;
  /* overflow: auto; */
  width: calc(100vw);
}

.fetch-student {
  margin-left: 5px;
}

.btn-warning {
  margin-left: 5px;
}

.student-container .react-bootstrap-table td:nth-child(1),
.qualification {
  display: none;
}

.btn-pass-qualification {
  margin-right: 5px;
}

.note {
  max-width: 90px;
  overflow: hidden;
}

@media print {
  thead {
    display: table-row-group;
  }
}

.btn-container-table {
  position: absolute;
}

.btn-clear,
.hide-show-qualification {
  margin: 5px;
}

.student-count {
  margin-left: 5px;
}

.react-bootstrap-table {
  transform: rotateX(180deg);
  overflow-x: auto;
  margin-top: 40px;
}
.student-course-table {
  transform: rotateX(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/StudentCourseTable/StudentCourseTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".table-foot {\n  display: none;\n}\n\n.sr-only {\n  display: none;\n}\n\n.react-bs-table-no-data {\n  text-align: center;\n}\n\n.export-container {\n  text-align: end;\n}\n.search-student {\n  display: grid;\n}\n\n.search-result {\n  margin-top: 10px;\n}\n\n.rank-custom-cell {\n  width: 8%;\n}\n\n.number-custom-cell {\n  width: 4%;\n}\n\n.sort-text {\n  margin-right: 20px;\n}\n\n.fa-spin {\n  margin-right: 5px;\n}\n\n.student-container {\n  margin-bottom: 500px;\n  margin-top: 70px !important;\n  /* overflow: auto; */\n  width: calc(100vw);\n}\n\n.fetch-student {\n  margin-left: 5px;\n}\n\n.btn-warning {\n  margin-left: 5px;\n}\n\n.student-container .react-bootstrap-table td:nth-child(1),\n.qualification {\n  display: none;\n}\n\n.btn-pass-qualification {\n  margin-right: 5px;\n}\n\n.note {\n  max-width: 90px;\n  overflow: hidden;\n}\n\n@media print {\n  thead {\n    display: table-row-group;\n  }\n}\n\n.btn-container-table {\n  position: absolute;\n}\n\n.btn-clear,\n.hide-show-qualification {\n  margin: 5px;\n}\n\n.student-count {\n  margin-left: 5px;\n}\n\n.react-bootstrap-table {\n  transform: rotateX(180deg);\n  overflow-x: auto;\n  margin-top: 40px;\n}\n.student-course-table {\n  transform: rotateX(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
